module.exports = __webpack_public_path__ + "img/metal@2x.e165a44.jpg";